import { useMemo } from "react";

import { useThumbnailManifest } from "./fetchThumbnailManifest";
import { generateSignedUrl } from "./generatePreSignedUrl";
import { parseM3u8ForLastThumbnail } from "./m3u8Parser";

import type { Cookie } from "@spwn/types/functions";

const POLLING_INTERVAL_MS = 2000;

export const useGetVideoThumbnailPresignedUrlForLive = ({
  cookie: { url: cookieUrl, cookie },
  enablePolling,
}: {
  cookie: Pick<Cookie, "url" | "cookie">;
  enablePolling: boolean;
}): string | undefined => {
  const { data: thumbnailManifestFileData } = useThumbnailManifest({
    cookie: { url: cookieUrl, cookie },
    refreshInterval: POLLING_INTERVAL_MS,
    enabled: enablePolling,
  });

  const thumbnailUrl = useMemo(() => {
    if (thumbnailManifestFileData === undefined) {
      console.warn("Thumbnail manifest file data is undefined.");
      return undefined;
    }

    const lastFileName = parseM3u8ForLastThumbnail(thumbnailManifestFileData);

    if (!lastFileName) {
      console.warn("No last thumbnail file name found.");
      return undefined;
    }

    return generateSignedUrl({
      manifestFileUrl: cookieUrl,
      cookie,
      fileName: lastFileName,
    });
  }, [thumbnailManifestFileData, cookieUrl, cookie]);

  return thumbnailUrl;
};
